/** Shared proportional font stack for all user-facing text. */
export const APP_FONT_FAMILY =
    '"Noto Sans", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif'
